// extracted by mini-css-extract-plugin
export default {"select-wrapper":"select-wrapper__2Xno2","select":"select__26FUu","selected":"selected__3KYzj"};